import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from './app.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'ngx-reference-manager';
  loadingCategories = false;

  constructor(
    private translate: TranslateService,
    private appService: AppService
  ) {
    this.translate.setDefaultLang('en');
    translate.use('en');
  }

  ngOnInit() {
    this.getCategories();
  }


  getCategories() {
    this.loadingCategories = true;
    this.appService.getCategories().subscribe(
      () => {
        this.loadingCategories = false;
      }
    );
  }

}
